import axios from 'axios';
import toast from 'react-hot-toast';

const useProductData = (lineItems) => {
  const getLatestProductData = async (productIdsString) => {
    try {
      const { data } = await axios.post(
        `/api/bigcommerce/catalog/products/get-all-products?idIn=${productIdsString}&include=variants`
      );
      return data;
    } catch (error) {
      console.error('Error fetching product data:', error.response?.status, error.response?.data);
      return error?.response?.data;
    }
  };

  const attachInventoryLevelWithCartItemsVariant = (data, resolve) => {
    if (!data) {
      // Handle the case where data is not available
      toast('Product is out of stock');
      resolve({ isOutOfStock: true });
      return;
    }
    const allItemsProductIds =
      lineItems?.physical_items
        ?.filter((item) => item.list_price !== 0)
        ?.map(({ product_id, variant_id, quantity, name }) => ({
          product_id,
          variant_id,
          quantity,
          name
        })) || [];

    const result = allItemsProductIds.map((item) => {
      const { product_id, variant_id, quantity } = item;
      const findProductFromAllAvailableListing = data?.find((product) => product.id == product_id);

      const getVariantFromListing = findProductFromAllAvailableListing?.variants?.find(
        (variant) => variant.id == variant_id
      );

      return {
        ...item,
        stockInBigCom: getVariantFromListing.inventory_level,
        isOutOfStock: getVariantFromListing.inventory_level - quantity < 0
      };
    });

    const isOutOfStock = result.some((item) => item.isOutOfStock);
    if (isOutOfStock) {
      toast('Product is out of stock');
    }
    resolve({ isOutOfStock });
  };

  return new Promise((resolve, reject) => {
    if (lineItems?.physical_items?.length) {
      const uniqueProductIds = Array.from(new Set(lineItems?.physical_items?.map((item) => item.product_id)));
      const productIdsString = uniqueProductIds.join(',');
      getLatestProductData(productIdsString)
        .then((data) => attachInventoryLevelWithCartItemsVariant(data, resolve))
        .catch((err) => reject(err));
    }
  });
};

export default useProductData;
